// Sections whose child menu stays open while the current path is inside them.
const PARENT_MENU_PATHS = [
    {pathname: "settings", id: "settings"},
    {pathname: "academics", id: "academicsSection"},
    {pathname: "academic-affairs", id: "academicAffairsSection"},
    {pathname: "admissions", id: "admissionsSection"},
    {pathname: "financial-aid", id: "financialAidSection"},
    {pathname: "student-account", id: "studentAccountSection"},
    {pathname: "student-services", id: "studentServicesSection"},
    {pathname: "career-services", id: "careerServicesSection"},
    {pathname: "integrations", id: "integrationsSection"}
]

export const getActiveParentMenuId = (pathname: string): string | null => {
    if (pathname.includes("report")) {
        return null
    }
    const parentMenu = PARENT_MENU_PATHS.find((menu) => pathname.includes(`/${menu.pathname}`))
    return parentMenu ? parentMenu.id : null
}
